import { PersonalInfo, Skill, Education, Achievement, ResumeFormat, PersonalInterest } from '../types';

export const defaultPersonalInfo: PersonalInfo = {
    name: "Yabets Kifle",
    title: "Systems Architect & Software Engineer",
    location: "Addis Ababa, Ethiopia",
    email: "jabez.kifle@gmail.com",
    phone: "+251 900 000 000",
    yearsOfExperience: 3,
    profileImage: "/image/me.jpg",
    profileImageAlt: "Yabets Kifle - Systems Architect",
    bio: "Systems Architect and Software Engineer with 3+ years of experience in structural application design. I specialize in building high-availability systems with React, TypeScript, and Node.js, focusing on performance, scalability, and technical precision."
};

export const defaultSkills: Skill[] = [
    { id: "react", name: "React", category: "frontend", proficiency: 5, yearsOfExperience: 3, icon: "Code2" },
    { id: "typescript", name: "TypeScript", category: "frontend", proficiency: 5, yearsOfExperience: 3, icon: "FileCode" },
    { id: "nodejs", name: "Node.js", category: "backend", proficiency: 4, yearsOfExperience: 2, icon: "Server" },
    { id: "postgresql", name: "PostgreSQL", category: "backend", proficiency: 4, yearsOfExperience: 2, icon: "Database" }
];

export const defaultEducation: Education[] = [
    {
        id: "1",
        institution: "Addis Ababa Institute of Technology",
        degree: "BSc in Software Engineering",
        location: "Addis Ababa, Ethiopia",
        startYear: 2019,
        endYear: 2024,
        achievements: ["Specialized in Distributed Systems and Software Architecture."],
        logo: "",
        logoAlt: "AAiT Logo"
    }
];

export const defaultAchievements: Achievement[] = [
    {
        id: "1",
        title: "Executive Technical Lead",
        issuer: "Project Alpha",
        date: "2023",
        description: "Led the architectural overhaul of a cross-platform fintech solution, reducing latency by 40%.",
        category: "certification"
    }
];

export const defaultResumeFormats: ResumeFormat[] = [
    {
        id: "pdf",
        name: "Executive Resume",
        format: "PDF",
        url: "/resume.pdf",
        lastUpdated: "March 2024",
        size: "245 KB",
        icon: "FileText"
    }
];

export const defaultInterests: PersonalInterest[] = [
    {
        id: "1",
        name: "Architectural Design",
        description: "Researching modern structural design and urban planning principles.",
        icon: "Home",
        category: "creative"
    }
];
